exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-upload .input-wrapper {\n    background-color: #007791!important;\n    height: 30px!important;\n}\n.file-upload .input-wrapper .file-upload-label .file-upload-icon {\n    font-size: 18px!important;\n}\n.file-upload .input-wrapper .file-upload-label {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    padding: 5px 10px !important;\n}\nlabel > span {\n    width: auto !important;\n    text-align: right !important;\n    padding-right: 0 !important;\n    border-right: none !important;\n}\n", ""]);

// exports
